import { SafetyCertificateOutlined } from "@ant-design/icons";
import { FC, useState } from "react";

import { SVScanModal } from "@/features/SupervisorScan/modals";
import { useAppSelector, useProtectedUserRoleSelector } from "@/hooks/redux";
import { isManagerRole } from "@/utils/business/isManagerRole";

import { StyledButton } from "./Styled";

interface SVScanButtonProps {
    taskId: string;
    pointId?: string;
}

export const SVScanButton: FC<SVScanButtonProps> = ({ taskId, pointId }) => {
    const role = useProtectedUserRoleSelector();
    const supervisorCheck = useAppSelector((s) => s.work.supervisorCheck);
    const checked = !!supervisorCheck[taskId] || isManagerRole(role);

    const [open, setOpen] = useState(false);

    return (
        <>
            <StyledButton
                $checked={checked}
                type="text"
                onClick={() => setOpen(true)}
                icon={<SafetyCertificateOutlined style={{ fontSize: 20 }} />}
            />

            <SVScanModal
                open={open}
                taskId={taskId}
                pointId={pointId}
                onClose={() => setOpen(false)}
            />
        </>
    );
};
